import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import banner1 from "../../../Assets/herosection/Banner1.png";
import banner2 from "../../../Assets/herosection/Banner2.png";
import banner3 from "../../../Assets/herosection/Banner3.png";
//import API from "../../Utils/api";
import API from "../../../Utils/api";
import toast from "react-hot-toast";

const Hero = () => {
  const [hero, setHero] = useState([]);
  const [loading, setLoading] = useState(true);

  // const images = [banner1, banner2, banner3];

  const fetchHero = async () => {
    setLoading(true);
    try {
      const res = await API.get(`/hero/get-all`);

      setHero(res.data?.hero || []);
    } catch (error) {
      console.error("Error fetching Hero:", error);
      toast.error("Failed to load Hero");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchHero();
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? hero.length - 1 : prev - 1));
  };
  const goNext = () => {
    setCurrentIndex((prev) => {
      if (hero.length === 0) return 0;
      return prev === hero.length - 1 ? 0 : prev + 1;
    });
  };

  useEffect(() => {
    if (hero.length === 0) return;

    const interval = setInterval(goNext, 5000);
    return () => clearInterval(interval);
  }, [hero]);

  if (loading) {
    return (
      <section className="w-full h-[40vh] flex items-center justify-center">
        <p className="text-gray-500">Loading banner...</p>
      </section>
    );
  }

  return (
    <section className="relative w-full h-[20vh] sm:h-[35vh] md:h-[77vh] overflow-hidden bg-yellow-50/30">
      {/* Slider Wrapper */}
      <div
        className="flex h-full transition-transform duration-700 ease-in-out"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {hero.map((item, index) => (
          <img
            key={index}
            src={item?.image?.[0]}
            alt={`Slide ${index + 1}`}
            loading="lazy"
            className="w-full object-fill flex-shrink-0 min-w-full"
          />
        ))}
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
        {hero.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full ${
              currentIndex === index ? "bg-[#1A3617]" : "bg-white/50"
            }`}
          />
        ))}
      </div>

      {/* Left Arrow */}
      <button
        onClick={goPrev}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/70 p-2 rounded-full text-white "
      >
        <ChevronLeft size={28} color="white" />
      </button>

      {/* Right Arrow */}
      <button
        onClick={goNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/80 p-2 rounded-full text-white "
      >
        <ChevronRight size={28} color="white" />
      </button>
    </section>
  );
};

export default Hero;
